var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"clients"},on:{"click":_vm.closeNav}},[_c('dama-clients')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }